import { useMutation } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

interface GeneratedBedConfiguration {
  bed_type?: string;
  quantity?: number;
}

export interface GeneratedBeddingConfigurationResponse {
  result?: {
    bed_grouping?: Array<Array<GeneratedBedConfiguration>>;
  };
}

export function useGenerateBeddingConfiguration() {
  return useMutation({
    mutationFn: (dealId: string) =>
      OffersService.generateBeddingConfiguration(dealId) as Promise<GeneratedBeddingConfigurationResponse>,
  });
}
